// Author YuJiaBei
// Date 2023-05-29 11:19:46

class InspectionRecord {
constructor({
        id = null,
        handleDescription = '',
        handleTime = '',
        attachment = '',
        attachmentList = ''}
= {}) {
    this.id = id;
    this.handleDescription = handleDescription;
    this.handleTime = handleTime;
    this.attachment = attachment;
    this.attachmentList = attachmentList;
}
}

function newEntity() {
return new InspectionRecord();
}

    function gridFields() {
    return Object.freeze([
        {
            key: 'id',
            label: 'label.em.inspection.inspectionRecord.grid.id',
            sortable: true,
            isDetail: true,
            form: {
                type: 'input'
            }
        },
        {
        key: 'emArchBasicDataCode',
        label: 'label.em.inspection.inspectionRecord.grid.emArchBasicDataCode',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'emArchBasicDataName',
        label: 'label.em.inspection.inspectionRecord.grid.emArchBasicDataName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'repairWorkOrderCode',
        label: 'label.em.inspection.inspectionRecord.grid.repairWorkOrderCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'repairWorkOrderJobContent',
        label: 'label.em.inspection.inspectionRecord.grid.repairWorkOrderJobContent',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'repairWorkOrderExecutor',
        label: 'label.em.inspection.inspectionRecord.grid.repairWorkOrderExecutor',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'repairWorkOrderStatus',
        label: 'label.em.inspection.inspectionRecord.grid.repairWorkOrderStatus',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'recordValue',
        label: 'label.em.inspection.inspectionRecord.grid.recordValue',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionScheduleDetailName',
        label: 'label.em.inspection.inspectionRecord.grid.inspectionScheduleDetailName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionCategoryName',
        label: 'label.em.inspection.inspectionRecord.grid.inspectionCategoryName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'inspectionResultName',
        label: 'label.em.inspection.inspectionRecord.grid.inspectionResultName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'statusName',
        label: 'label.em.inspection.inspectionRecord.grid.statusName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'deptName',
        label: 'label.em.inspection.inspectionRecord.grid.deptName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'recorder',
        label: 'label.em.inspection.inspectionRecord.grid.recorder',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'abnormalDescription',
        label: 'label.em.inspection.inspectionRecord.grid.abnormalDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'abnormalTime',
        label: 'label.em.inspection.inspectionRecord.grid.abnormalTime',
        sortable: true,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'handleDescription',
        label: 'label.em.inspection.inspectionRecord.grid.handleDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'handleTime',
        label: 'label.em.inspection.inspectionRecord.grid.handleTime',
        sortable: true,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'attachmentList',
        label: 'label.em.inspection.inspectionRecord.grid.attachmentList',
        sortable: true,
            isDetail: true,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
        }
        },
    ])}

const filter = {
    emArchBasicDataCodeFilter : '',
    inspectionWorkOrderIdFilter : '',
    inspectionScheduleDetailIdFilter : '',
    inspectionScheduleDetailNameFilter : '',
    inspectionResultIdFilter : '',
    inspectionResultGenerateAbnormalWorkflowFilter : '',
    recordValueFilter : '',
    statusFilter : '',
    createdTimeGreatThanFilter : '',
    createdTimeLessThanFilter : '',
    workflowQueryTypeFilter : '',
    inspectionTypeFilter : '',
    deptNameFilter : '',
    recorderFilter : '',
    abnormalTimeFilter : '',
    handleTimeFilter : '',
    repairWorkOrderCodeFilter : '',
    repairWorkOrderStatusFilter : '',
    repairWorkOrderExecutorFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'emArchBasicDataCodeFilter',
        label: 'label.em.inspection.inspectionRecord.filter.emArchBasicDataCode',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emArchBasicData'
            ,correspondingField: 'code'
                }
        },
        {
        key: 'inspectionWorkOrderIdFilter',
        label: 'label.em.inspection.inspectionRecord.filter.inspectionWorkOrderId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionWorkOrder'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inspectionScheduleDetailIdFilter',
        label: 'label.em.inspection.inspectionRecord.filter.inspectionScheduleDetailId',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionScheduleDetail'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'inspectionScheduleDetailNameFilter',
        label: 'label.em.inspection.inspectionRecord.filter.inspectionScheduleDetailName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionResultIdFilter',
        label: 'label.em.inspection.inspectionRecord.filter.inspectionResultId',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionResult'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'recordValueFilter',
        label: 'label.em.inspection.inspectionRecord.filter.recordValue',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'statusFilter',
        label: 'label.em.inspection.inspectionRecord.filter.status',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'InspectionRecord',statusFilter:1}
        }
        },
        {
        key: 'createdTimeGreatThanFilter',
        label: 'label.em.inspection.inspectionRecord.filter.createdTimeGreatThan',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'createdTimeLessThanFilter',
        label: 'label.em.inspection.inspectionRecord.filter.createdTimeLessThan',
        disabled: false,
        form: {
        type: 'datepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'inspectionTypeFilter',
        label: 'label.em.inspection.inspectionRecord.filter.inspectionType',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'inspectionCategory'
            ,showLabelSelectOne: true
                }
        },
        {
        key: 'deptNameFilter',
        label: 'label.em.inspection.inspectionRecord.filter.deptName',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'recorderFilter',
        label: 'label.em.inspection.inspectionRecord.filter.recorder',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'abnormalTimeFilter',
        label: 'label.em.inspection.inspectionRecord.filter.abnormalTime',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'handleTimeFilter',
        label: 'label.em.inspection.inspectionRecord.filter.handleTime',
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'repairWorkOrderCodeFilter',
        label: 'label.em.inspection.inspectionRecord.filter.repairWorkOrderCode',
        disabled: false,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'repairWorkOrderStatusFilter',
        label: 'label.em.inspection.inspectionRecord.filter.repairWorkOrderStatus',
        disabled: false,
        form: {
        type: 'entitySelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emActProcessStatus'
            ,showLabelSelectOne: true
                    ,selectFilter:{processBusinessEntityFilter:'RepairWorkOrder',statusFilter:1}
        }
        },
        {
        key: 'repairWorkOrderExecutorFilter',
        label: 'label.em.inspection.inspectionRecord.filter.repairWorkOrderExecutor',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'handleDescription',
        label: 'label.em.inspection.inspectionRecord.entity.handleDescription',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'handleTime',
        label: 'label.em.inspection.inspectionRecord.entity.handleTime',
        sortable: true,
        disabled: false,
        form: {
        type: 'datetimepicker',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'attachmentList',
        label: 'label.em.inspection.inspectionRecord.entity.attachment',
        sortable: false,
        disabled: false,
        form: {
        type: 'emAttachment',
        modalMultiSelectedType: 'string'
            ,correspondingField: 'attachment'
                }
        }
]

export {InspectionRecord, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
